import {
  SolMenuGroup,
  SolMenuItem,
} from '../components/popover/sol-popover-menu-content/sol-popover-menu-content.state';
import { SolShortcutAction } from '../services/shortcut.service';

import { SolNavbarItem } from '../models/sol-navigation';

export class MenuTools {
  public static filterMenuGroups(groups: SolMenuGroup[], predicate: (item: SolMenuItem) => boolean): SolMenuGroup[] {
    return groups
      .map(group => {
        return {
          ...group,
          items: group.items.filter(predicate),
        };
      })
      .filter(group => group.items.length > 0);
  }

  public static toShortcutActions(
    menuGroups: SolMenuGroup[],
    callback: (actionId: string) => boolean,
  ): SolShortcutAction[] {
    const result: SolShortcutAction[] = [];
    for (const group of menuGroups) {
      for (const item of group.items) {
        if (!!item.shortcut) {
          result.push({
            shortcut: item.shortcut,
            action: () => callback(item.id),
          });
        }
      }
    }
    return result;
  }

  public static navigateMenu(
    menuGroups: SolMenuGroup[],
    currentItem: string,
    next: boolean,
    includeEmpty: boolean = false,
  ): string {
    const actionIds = menuGroups.flatMap(group => group.items).map(item => item.id);
    const index = currentItem === '' ? -1 : actionIds.indexOf(currentItem);
    let newIndex: number = index;
    if (next) {
      newIndex = index + 1 < actionIds.length ? index + 1 : index;
    } else if (includeEmpty && index <= 0) {
      return '';
    } else if (index > 0) {
      newIndex = index - 1;
    } else if (index < 0) {
      newIndex = 0;
    }
    return actionIds[newIndex];
  }

  public static navbarToMenu(items: SolNavbarItem[]): SolMenuGroup[] {
    // Todo: rework to menu tree
    const result: SolMenuGroup[] = [];
    let groupItems: SolMenuItem[] = [];
    let index = 0;
    while (index < items.length) {
      const item = items[index];
      if (item.hasAuthority && item.showChildrenInNavbar) {
        // Collect menu items
        if (item.isMenuGroup) {
          if (groupItems.length > 0) {
            result.push({
              items: groupItems,
            });
            groupItems = [];
          }

          for (const subItem of item.children) {
            if (subItem.hasAuthority && subItem.showChildrenInNavbar) {
              groupItems.push({
                id: subItem.id,
                icon: subItem.icon,
                name: subItem.displayName,
              });
            }
          }

          // Only add if there are items
          if (items.length > 0) {
            result.push({
              name: item.displayName,
              items: groupItems,
            });
            groupItems = [];
          }
        } else {
          groupItems.push({
            id: item.id,
            icon: item.icon,
            name: item.displayName,
          });
        }
      }

      // Next
      index++;

      // Add last items
      if (index === items.length && groupItems.length > 0) {
        result.push({
          items: groupItems,
        });
        groupItems = [];
      }
    }
    return result;
  }
}
